import type { ProjectSoftwareRule } from "@zentrack/domain";

/**
 * Build a "Client / Project" label for display. Falls back to friendly names
 * when the related records have been removed.
 */
export function projectLabel(
  snapshot: {
    clients: Array<{ id: string; name: string }>;
    projects: Array<{ id: string; clientId: string; name: string }>;
  },
  projectId: string,
): string {
  const project = snapshot.projects.find((candidate) => candidate.id === projectId);
  const client = snapshot.clients.find((candidate) => candidate.id === project?.clientId);
  return `${client?.name ?? "Unknown Client"} / ${project?.name ?? "Unknown Project"}`;
}

const MIN_PROJECT_NAME_LENGTH = 4;

export function validateProjectName(name: string): string | null {
  const trimmed = name.trim();
  if (trimmed.length > 0 && trimmed.length < MIN_PROJECT_NAME_LENGTH) {
    return `Project name must be at least ${MIN_PROJECT_NAME_LENGTH} characters.`;
  }
  if (trimmed.length < MIN_PROJECT_NAME_LENGTH) {
    return `Project name must be at least ${MIN_PROJECT_NAME_LENGTH} characters.`;
  }
  return null;
}

export const EMPTY_SOFTWARE_RULES: ProjectSoftwareRule[] = [];
